 
<template>
<Tooltip transfer :content="validMsg" theme="err" :disabled="!(validErr&&validErrMsgTip)"  class="ivu-table-cell-tooltip">
    <div  :class="getEditClass" @mouseenter="validErrMsgTipIn" @mouseleave="validErrMsgTipOut">
        <div :class="[prefixCls + '-rel']">
            <template>
                <Tooltip transfer :content="myContent" :disabled="!showTooltip" class="ivu-table-cell-tooltip">
                    <p ref="content" @mouseenter="handleTooltipIn" @mouseleave="handleTooltipOut" class="ivu-table-cell-tooltip-content">{{ myContent }}</p>
                </Tooltip>
            </template>
        </div>
        <template>
            <div
                :class="[prefixCls + '-popper']"
                v-if="visible">
                <div :class="[prefixCls + '-content']">
                    <inumber 
                        ref="inumber" 
                        v-model="myContent"
                        :precision="editCfg.precision"
                        :max="editCfg.max !== undefined ? editCfg.max : (editCfg.setMax ? editCfg.setMax(col,row) : undefined)"
                        :min="editCfg.min !== undefined ? editCfg.min : (editCfg.setMin ? editCfg.setMin(col,row) : undefined)"
                        :showUpDown="false" 
                        @on-change="change"  
                        :disabled="editCfg.disabled||getDisabled()" 
                        @on-blur="blur" 
                        :formatter="editCfg.formatter"></inumber>
                </div>
            </div>
        </template>
    </div>
</Tooltip>
</template>
<script>
    const prefixCls = 'table-edit';
    import Tooltip from '../../tooltip/tooltip.vue';
    export default { 
        name: 'plugInumber',
        components:{Tooltip},
        props: {
            content: {
                type: [String, Number],
                default: ''
            },
            col:[String, Number,Object],
            row: [String, Number, Object],
            rowOriginal:[String, Number, Object],
            editCfg: Object,
            disabled: {
                type: Boolean,
                default: false
            },
            visible: {
                type: Boolean,
                default: false
            },
            always: {
                type: Boolean,
                default: false
            },
            validErr:{
                type: Boolean,
                default: false
            },
            validMsg:String,
            editAlways:{
                type: Boolean,
                default: false
            },
            maxWidth: {
                type: [String, Number]
            },
            precision: {
                type: Number
            },
            max: {
                type: Number,
                default: Infinity
            },
            min: {
                type: Number,
                default: -Infinity
            }
        },
        data () {
            return {
                prefixCls: prefixCls,
                myContent:"",
                showTooltip: false,
                validErrMsgTip:false
            };
        },
        computed: {
            getEditClass() {
                return [
                    `${this.prefixCls}`,
                    {
                        [`${this.prefixCls}-always`]: (this.editAlways||this.always)&&!this.visible,
                        [`${this.prefixCls}-disabled`]:this.getDisabled(),
                        [`${this.prefixCls}-cell-valid-err`]: this.validErr === true&&!this.visible
                    }
                ];
            }
        },
        watch: {
            visible(newValue,oldValue){
                this.$nextTick(function(){
                    if(newValue)this.$refs.inumber.setfocus()
                })
            },
            content(){
                this.setMyContent()
            }
        },
        methods: {
            blur(){
                this.editCfg.blur&&this.editCfg.blur(this.myContent)
                if(this.content==""&&this.myContent!=""){this.$emit('onChange',this.myContent,this.col)}
                this.$emit('onChangeShowEdit',false,this.myContent)
            },
            change(value){
                this.$emit('onChange',value,this.col)
            },
            handleTooltipIn () {
                const $content = this.$refs.content;
                this.showTooltip = $content.scrollWidth > $content.offsetWidth;
            },
            handleTooltipOut () {
                this.showTooltip = false;
            },
            validErrMsgTipIn(){
                this.validErrMsgTip=true
            },
            validErrMsgTipOut(){
                this.validErrMsgTip=false
            },
            getDisabled(item) {
                let myDisabled=this.editCfg.setDisabled
                    ? this.editCfg.setDisabled(this.col, this.row, this.editCfg)
                    : this.editCfg.disabled;
                    if(myDisabled=='true'||myDisabled=='false'){
                        this.$emit("setColEditDisabled", myDisabled);
                    }
                    return myDisabled
            },
            setMyContent(){
                let str=this.content+''
                this.myContent = str?this.$utils.edit.fixed(str,this.editCfg.precision||0)+'':str
            }
        },
        mounted () {
            this.setMyContent()
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/common/table/plug/number.vue